import React, { useEffect, useState } from 'react';

const ConfigEditor = ({ config, onConfigChange, isExpanded, onToggleExpanded }) => {
  const [text, setText] = useState(JSON.stringify(config, null, 2));
  const [error, setError] = useState('');

  useEffect(() => {
    setText(JSON.stringify(config, null, 2));
    setError('');
  }, [config]);

  const handleChange = (event) => {
    const nextText = event.target.value;
    setText(nextText);
    try {
      const nextConfig = JSON.parse(nextText);
      setError('');
      onConfigChange(nextConfig);
    } catch (parseError) {
      setError(parseError.message);
    }
  };

  return (
    <div style={{ marginBottom: '20px' }}>
      <button
        className="btn"
        type="button"
        onClick={onToggleExpanded}
        style={{ marginBottom: isExpanded ? '12px' : 0 }}
      >
        {isExpanded ? 'Hide configuration editor' : 'Edit configuration'}
      </button>

      {isExpanded && (
        <>
          <textarea
            aria-label="Deployment configuration JSON"
            value={text}
            onChange={handleChange}
            spellCheck="false"
            style={{
              width: '100%',
              minHeight: '320px',
              padding: '12px',
              border: `2px solid ${error ? '#dc3545' : '#e0e6ed'}`,
              borderRadius: '8px',
              fontFamily: 'Monaco, Menlo, Ubuntu Mono, monospace',
              fontSize: '0.85rem',
              resize: 'vertical'
            }}
          />
          {error && (
            <div style={{ color: '#721c24', marginTop: '8px' }}>
              Invalid JSON: {error}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ConfigEditor;
